angular
    .module('tradersyard')
    .directive('searchSuggestWidget', [
        '$window',
        function ($window) {
            return {
                link: function ($scope, $element, $attr) {
                    $scope.active = 0;

                    function isElement(obj) {
                        try {
                            //Using W3 DOM2 (works for FF, Opera and Chrom)
                            return obj instanceof HTMLElement;
                        } catch (e) {
                            //Browsers not supporting W3 DOM2 don't have HTMLElement and
                            //an exception is thrown and we end up here. Testing some
                            //properties that all elements have. (works on IE7)
                            return (
                                typeof obj === 'object' &&
                                obj.nodeType === 1 &&
                                typeof obj.style === 'object' &&
                                typeof obj.ownerDocument === 'object'
                            );
                        }
                    }

                    angular.element($window).bind('click', function ($event) {
                        var node = angular.element($event.target);
                        var target = false;

                        while (node[0] !== undefined) {
                            if (isElement(node[0]) && $element[0].isEqualNode(node[0])) {
                                target = true;
                                break;
                            }

                            node = node.parent();
                        }

                        if ($scope.active !== target) {
                            $scope.active = target;

                            if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                                $scope.$apply();
                            }
                        }
                    });
                },
            };
        },
    ])
    .controller('Search.Widget.Ctrl', [
        '$scope',
        '$timeout',
        '$location',
        'graph-search-factory',
        'search-query-filter',
        '$flex',
        'graph-like-factory',
        '$rootScope',
        function ($scope, $timeout, $location, $factory, $filter, $flex, $like, $root) {
            var t, wait;

            angular.extend($scope, $flex.data);

            $scope.progress = 0;
            $scope.empty = true;
            $scope.nodes = {};
            $scope.entry = undefined;
            $scope.q = $location.search().q;
            $scope.params = {
                q: $scope.q,
                page: 0,
                limit: 25,
            };

            $scope.userParams = {
                'data-feed': null,
                'endorse-tag': null,
                'trading-style': null,
                country: null,
                state: null,
                city: null,
                gender: null,
            };

            $scope.$on('search-change-entry', function (e, entry) {
                $scope.entry = entry;
                $scope.empty = true;
                $scope.params.page = 0;
                $scope.submit();
            });

            $scope.$on('search-query-scroll', function (e, next) {
                $scope.submit(undefined, next);
            });

            $scope.$on('search.reload', function (e, userParams) {
                $scope.userParams = userParams;
                $scope.reloadSearch();
            });

            $scope.submit = function (goto, next) {
                $scope.progress = 1;

                if ($scope.type === 'goto' || goto === true) {
                    var url =
                        '/search?q=' +
                        ($scope.q ? encodeURI($scope.q) : '') +
                        '#' +
                        ($scope.place ? $scope.place : 'user');

                    window.location.href = url;
                } else {
                    ++$scope.params.page;
                    $scope.empty = true;
                    $scope.params.q = $scope.q;

                    switch ($scope.entry) {
                        case undefined:
                            if ($scope.params.page === 1) {
                                $factory.all({ params: $scope.params }).then(function (response) {
                                    if (response.data.state === 0) {
                                        $scope.nodes = response.data.data;

                                        for (var type in response.data.data) {
                                            if (response.data.data[type].length > 0) {
                                                $scope.empty = false;
                                                break;
                                            }
                                        }

                                        $scope.load($scope.empty, $scope.nodes, $scope.q);
                                    }

                                    $scope.process = 0;
                                });
                            } else {
                                $factory
                                    .entry('post')
                                    .search({ params: $scope.params })
                                    .then(function (response) {
                                        if (response.data.state === 0 && response.data.data.length > 0) {
                                            $scope.nodes.post = $scope.nodes.post.concat(response.data.data);

                                            for (var type in $scope.nodes) {
                                                if ($scope.nodes[type].length > 0) {
                                                    $scope.empty = false;
                                                    break;
                                                }
                                            }

                                            $scope.load($scope.empty, $scope.nodes, $scope.q);

                                            if (next) next();
                                        }

                                        $scope.process = 0;
                                    });
                            }
                            break;
                        default:
                            if ($scope.params.page > 1 && $scope.entry === 'forum') {
                                var subparams = angular.copy($scope.params);

                                angular.extend(subparams, {
                                    scope: 'forum',
                                });

                                $factory
                                    .entry('post')
                                    .search({ params: subparams })
                                    .then(function (response) {
                                        if (response.data.state === 0 && response.data.data.length > 0) {
                                            if ($scope.params.page <= 1) {
                                                $scope.nodes.post = response.data.data;
                                            } else {
                                                $scope.nodes.post = $scope.nodes.post.concat(response.data.data);
                                            }

                                            for (var type in $scope.nodes) {
                                                if ($scope.nodes[type].length > 0) {
                                                    $scope.empty = false;
                                                    break;
                                                }
                                            }

                                            $scope.load($scope.empty, $scope.nodes, $scope.q);

                                            if (next) next();
                                        }

                                        $scope.process = 0;
                                    });
                            } else {
                                var requestParams;

                                if ($scope.entry === 'user') {
                                    requestParams = angular.extend(angular.copy($scope.params), $scope.userParams);
                                } else {
                                    requestParams = angular.copy($scope.params);
                                }

                                $factory
                                    .entry($scope.entry)
                                    .search({
                                        params: requestParams,
                                    })
                                    .then(function (response) {
                                        var type;

                                        if ($scope.entry === 'forum') {
                                            if (response.data.state === 0) {
                                                $scope.nodes = response.data.data;

                                                for (type in response.data.data) {
                                                    if (response.data.data[type].length > 0) {
                                                        $scope.empty = false;
                                                        break;
                                                    }
                                                }

                                                $scope.load($scope.empty, $scope.nodes, $scope.q);

                                                if (next) next();
                                            }
                                        } else {
                                            if (response.data.state === 0 && response.data.data.length > 0) {
                                                if ($scope.nodes[$scope.entry] === undefined)
                                                    $scope.nodes[$scope.entry] = [];

                                                if ($scope.params.page <= 1) {
                                                    $scope.nodes[$scope.entry] = response.data.data;
                                                } else {
                                                    $scope.nodes[$scope.entry] = $scope.nodes[$scope.entry].concat(
                                                        response.data.data
                                                    );
                                                }

                                                for (type in $scope.nodes) {
                                                    if ($scope.nodes[type].length > 0) {
                                                        $scope.empty = false;
                                                        break;
                                                    }
                                                }

                                                $scope.load($scope.empty, $scope.nodes, $scope.q);

                                                if (next) next();
                                            }
                                        }

                                        $scope.process = 0;
                                    });
                            }

                            break;
                    }
                }
            };

            $scope.load = function (empty, nodes, q) {
                $root.$broadcast('search-data-update', empty, nodes, q);
            };

            $scope.scroll = function (nodes) {
                $root.$broadcast('search-scroll-update', nodes);
            };

            $scope.goto = function () {
                var url =
                    '/search?q=' +
                    ($scope.q ? encodeURI($scope.q) : '') +
                    '#' +
                    ($scope.place ? $scope.place : 'suggest');

                window.location.href = url;
            };

            $scope.reloadSearch = function () {
                wait = 1;
                if (t) $timeout.cancel(t);

                t = $timeout(function () {
                    $scope.empty = true;
                    $scope.params.page = 0;
                    $scope.nodes.user = [];
                    $scope.submit();
                }, 0);
            };

            // $scope.$watch(function() {
            //     return $scope.userParams['data-feed'];
            // }, function (val, $nval) {
            //     console.log(val);
            //     if (val !== $nval) {
            //         $scope.reloadSearch();
            //     }
            // });

            // $scope.$watch(function() {
            //     return $scope.userParams.gender;
            // }, function (val, $nval) {
            //     if (val !== $nval) {
            //         $scope.reloadSearch();
            //     }
            // });
            //
            // $scope.$watch(function() {
            //     return $scope.userParams.city;
            // }, function (val, $nval) {
            //     if (val !== $nval) {
            //         $scope.reloadSearch();
            //     }
            // });

            // $scope.$watch(function() {
            //     return $scope.userParams["trading-style"];
            // }, function (val, $nval) {
            //     console.log(val !== $nval);
            //     if (val !== $nval) {
            //         $scope.reloadSearch();
            //     }
            // });

            // $scope.$watch(function() {
            //     return $scope.userParams["endorse-tag"];
            // }, function (val, $nval) {
            //     if (val !== $nval) {
            //         $scope.reloadSearch();
            //     }
            // });

            // $scope.$watch(function() {
            //     return $scope.userParams.country;
            // }, function (val, $nval) {
            //     if (val !== $nval) {
            //         $scope.reloadSearch();
            //     }
            // });

            $scope.noop = function () {};

            $scope.$watch(
                function () {
                    return $scope.q;
                },
                function (val, $nval) {
                    if (val !== $nval) {
                        wait = 1;
                        if (t) $timeout.cancel(t);

                        t = $timeout(
                            function () {
                                $scope.params.page = 0;
                                $root.$broadcast('search-q-change', $scope.q);
                                $scope.submit();
                            },
                            $scope.type === 'goto' ? 2000 : 0
                        );
                    }
                }
            );
        },
    ]);
